import { atom } from "jotai";
export const selectedCourseBookingAtom = atom(null);
export const selectedCourseBookingManifestAtom = atom([]);
export const clickedCourseScheduleBoxIndexAtom = atom();
